module.exports = __webpack_public_path__ + "static/2-4db033177e8770121ae4f6a061ec340c.png";